module.exports = __webpack_public_path__ + "img/injectionsteps_step8.70bc878e.png";